"use strict";

var _toConsumableArray = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateNonce = exports.checkContractWalletSignature = exports.SiweMessage = exports.SignatureType = exports.ErrorTypes = void 0;
var random_1 = require("@stablelib/random");
// TODO: Figure out how to get types from this lib:
var ethers_1 = require("ethers");
var siwe_parser_1 = require("@spruceid/siwe-parser");
/**
 * Possible message error types.
 */
var ErrorTypes;
(function (ErrorTypes) {
  /**Thrown when the `validate()` function can verify the message. */
  ErrorTypes["INVALID_SIGNATURE"] = "Invalid signature.";
  /**Thrown when the `expirationTime` is present and in the past. */
  ErrorTypes["EXPIRED_MESSAGE"] = "Expired message.";
  /**Thrown when some required field is missing. */
  ErrorTypes["MALFORMED_SESSION"] = "Malformed session.";
})(ErrorTypes = exports.ErrorTypes || (exports.ErrorTypes = {}));
/**@deprecated
 * Possible signature types that this library supports.
 *
 * This enum will be removed in future releases. And signature type will be
 * inferred from version.
 */
var SignatureType;
(function (SignatureType) {
  /**EIP-191 signature scheme */
  SignatureType["PERSONAL_SIGNATURE"] = "Personal signature";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
var SiweMessage = /*#__PURE__*/function () {
  /**
   * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
   * string or an object. If a string is used an ABNF parser is called to
   * validate the parameter, otherwise the fields are attributed.
   * @param param {string | SiweMessage} Sign message as a string or an object.
   */
  function SiweMessage(param) {
    _classCallCheck(this, SiweMessage);
    if (typeof param === 'string') {
      var parsedMessage = new siwe_parser_1.ParsedMessage(param);
      this.domain = parsedMessage.domain;
      this.address = parsedMessage.address;
      this.statement = parsedMessage.statement;
      this.uri = parsedMessage.uri;
      this.version = parsedMessage.version;
      this.nonce = parsedMessage.nonce;
      this.issuedAt = parsedMessage.issuedAt;
      this.expirationTime = parsedMessage.expirationTime;
      this.notBefore = parsedMessage.notBefore;
      this.requestId = parsedMessage.requestId;
      this.chainId = parsedMessage.chainId;
      this.resources = parsedMessage.resources;
    } else {
      Object.assign(this, param);
      if (typeof this.chainId === 'string') {
        this.chainId = parseInt(this.chainId);
      }
    }
  }
  /**
   * Given a sign message (EIP-4361) returns the correct matching groups.
   * @param message {string}
   * @returns {RegExpExecArray} The matching groups for the message
   */
  _createClass(SiweMessage, [{
    key: "regexFromMessage",
    value: function regexFromMessage(message) {
      var parsedMessage = new siwe_parser_1.ParsedMessageRegExp(message);
      return parsedMessage.match;
    }
    /**
     * This function can be used to retrieve an EIP-4361 formated message for
     * signature, although you can call it directly it's advised to use
     * [signMessage()] instead which will resolve to the correct method based
     * on the [type] attribute of this object, in case of other formats being
     * implemented.
     * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
     */
  }, {
    key: "toMessage",
    value: function toMessage() {
      var header = "".concat(this.domain, " wants you to sign in with your Ethereum account:");
      var uriField = "URI: ".concat(this.uri);
      var prefix = [header, this.address].join('\n');
      var versionField = "Version: ".concat(this.version);
      if (!this.nonce) {
        this.nonce = (0, exports.generateNonce)();
      }
      var chainField = "Chain ID: " + this.chainId || '1';
      var nonceField = "Nonce: ".concat(this.nonce);
      var suffixArray = [uriField, versionField, chainField, nonceField];
      if (this.issuedAt) {
        Date.parse(this.issuedAt);
      }
      this.issuedAt = this.issuedAt ? this.issuedAt : new Date().toISOString();
      suffixArray.push("Issued At: ".concat(this.issuedAt));
      if (this.expirationTime) {
        var expiryField = "Expiration Time: ".concat(this.expirationTime);
        suffixArray.push(expiryField);
      }
      if (this.notBefore) {
        suffixArray.push("Not Before: ".concat(this.notBefore));
      }
      if (this.requestId) {
        suffixArray.push("Request ID: ".concat(this.requestId));
      }
      if (this.resources) {
        suffixArray.push(["Resources:"].concat(_toConsumableArray(this.resources.map(function (x) {
          return "- ".concat(x);
        }))).join('\n'));
      }
      var suffix = suffixArray.join('\n');
      prefix = [prefix, this.statement].join('\n\n');
      if (this.statement) {
        prefix += '\n';
      }
      return [prefix, suffix].join('\n');
    }
    /** @deprecated
     * signMessage method is deprecated, use prepareMessage instead.
     *
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */
  }, {
    key: "signMessage",
    value: function signMessage() {
      console && console.warn && console.warn('signMessage method is deprecated, use prepareMessage instead.');
      return this.prepareMessage();
    }
    /**
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */
  }, {
    key: "prepareMessage",
    value: function prepareMessage() {
      var message;
      switch (this.version) {
        case '1':
          {
            message = this.toMessage();
            break;
          }
        default:
          {
            message = this.toMessage();
            break;
          }
      }
      return message;
    }
    /**
     * Validates the integrity of the fields of this objects by matching it's
     * signature.
     * @param provider A Web3 provider able to perform a contract check, this is
     * required if support for Smart Contract Wallets that implement EIP-1271 is
     * needed.
     * @returns {Promise<SiweMessage>} This object if valid.
     */
  }, {
    key: "validate",
    value: function validate() {
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.signature;
      var provider = arguments.length > 1 ? arguments[1] : undefined;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var message, missing, addr, isValidSignature, parsedMessage, exp;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        message = this.prepareMessage();
                        _context.prev = 1;
                        missing = [];
                        if (!message) {
                          missing.push('`message`');
                        }
                        if (!signature) {
                          missing.push('`signature`');
                        }
                        if (!this.address) {
                          missing.push('`address`');
                        }
                        if (!(missing.length > 0)) {
                          _context.next = 8;
                          break;
                        }
                        throw new Error("".concat(ErrorTypes.MALFORMED_SESSION, " missing: ").concat(missing.join(', '), "."));
                      case 8:
                        _context.prev = 8;
                        addr = ethers_1.ethers.utils.verifyMessage(message, signature);
                        _context.next = 14;
                        break;
                      case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](8);
                      case 14:
                        _context.prev = 14;
                        if (!(addr !== this.address)) {
                          _context.next = 27;
                          break;
                        }
                        _context.prev = 16;
                        _context.next = 19;
                        return (0, exports.checkContractWalletSignature)(this, signature, provider);
                      case 19:
                        isValidSignature = _context.sent;
                        if (isValidSignature) {
                          _context.next = 22;
                          break;
                        }
                        throw new Error("".concat(ErrorTypes.INVALID_SIGNATURE, ": ").concat(addr, " !== ").concat(this.address));
                      case 22:
                        _context.next = 27;
                        break;
                      case 24:
                        _context.prev = 24;
                        _context.t1 = _context["catch"](16);
                        throw _context.t1;
                      case 27:
                        return _context.finish(14);
                      case 28:
                        parsedMessage = new SiweMessage(message);
                        if (!parsedMessage.expirationTime) {
                          _context.next = 35;
                          break;
                        }
                        exp = new Date(parsedMessage.expirationTime).getTime();
                        if (!isNaN(exp)) {
                          _context.next = 33;
                          break;
                        }
                        throw new Error("".concat(ErrorTypes.MALFORMED_SESSION, " invalid expiration date."));
                      case 33:
                        if (!(new Date().getTime() >= exp)) {
                          _context.next = 35;
                          break;
                        }
                        throw new Error(ErrorTypes.EXPIRED_MESSAGE);
                      case 35:
                        resolve(parsedMessage);
                        _context.next = 41;
                        break;
                      case 38:
                        _context.prev = 38;
                        _context.t2 = _context["catch"](1);
                        reject(_context.t2);
                      case 41:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, this, [[1, 38], [8, 12, 14, 28], [16, 24]]);
                }));
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    }
  }]);
  return SiweMessage;
}();
exports.SiweMessage = SiweMessage;
/**
 * This method calls the EIP-1271 method for Smart Contract wallets
 * @param message The EIP-4361 parsed message
 * @param provider Web3 provider able to perform a contract check (Web3/EthersJS).
 * @returns {Promise<boolean>} Checks for the smart contract (if it exists) if
 * the signature is valid for given address.
 */
var checkContractWalletSignature = function checkContractWalletSignature(message, signature, provider) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var abi, walletContract, hashMessage;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (provider) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", false);
        case 2:
          abi = ['function isValidSignature(bytes32 _message, bytes _signature) public view returns (bool)'];
          _context3.prev = 3;
          walletContract = new ethers_1.Contract(message.address, abi, provider);
          hashMessage = ethers_1.utils.hashMessage(message.signMessage());
          _context3.next = 8;
          return walletContract.isValidSignature(hashMessage, signature);
        case 8:
          return _context3.abrupt("return", _context3.sent);
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](3);
          throw _context3.t0;
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 11]]);
  }));
};
exports.checkContractWalletSignature = checkContractWalletSignature;
/**
 * This method leverages a native CSPRNG with support for both browser and Node.js
 * environments in order generate a cryptographically secure nonce for use in the
 * SiweMessage in order to prevent replay attacks.
 *
 * 96 bits has been chosen as a number to sufficiently balance size and security considerations
 * relative to the lifespan of it's usage.
 *
 * @returns cryptographically generated random nonce with 96 bits of entropy encoded with
 * an alphanumeric character set.
 */
var generateNonce = function generateNonce() {
  return (0, random_1.randomStringForEntropy)(96);
};
exports.generateNonce = generateNonce;